/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IComponentNodeProps, ISingleSlideCarouselProps, SingleSlideCarousel } from '@msdyn365-commerce-modules/utilities';

import { IDobbiesContentBlockCarouselData } from './dobbies-content-block-carousel.data';
import { IDobbiesContentBlockCarouselProps } from './dobbies-content-block-carousel.props.autogenerated';

export interface IDobbiesContentBlockCarouselViewProps extends IDobbiesContentBlockCarouselProps<IDobbiesContentBlockCarouselData> {
    SingleSlideCarouselComponentProps: IComponentNodeProps<ISingleSlideCarouselProps>;
}

/**
 *
 * DobbiesContentBlockCarousel component
 * @extends {React.PureComponent<IDobbiesContentBlockCarouselProps<IDobbiesContentBlockCarouselData>>}
 */
class DobbiesContentBlockCarousel extends React.PureComponent<IDobbiesContentBlockCarouselProps<IDobbiesContentBlockCarouselData>> {
    public render(): JSX.Element | null {
        const { resources } = this.props;
        const viewProps: IDobbiesContentBlockCarouselViewProps = {
            ...this.props,
            SingleSlideCarouselComponentProps: {
                tag: SingleSlideCarousel,
                className: '',
                flipperPrevLabel: resources.flipperPrevious,
                flipperNextLabel: resources.flipperNext,
                parentId: this.props.id
            } as IComponentNodeProps<ISingleSlideCarouselProps>
        };
        return this.props.renderView(viewProps);
    }
}

export default DobbiesContentBlockCarousel;
